// EditEventPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EventForm from "./CreateEvent";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function EditEventPage() {
  const { eventId } = useParams();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/events/${eventId}`);
        if (!res.ok) throw new Error(`Feil ved henting (${res.status})`);
        const data = await res.json();
        setEventData(data);
      } catch (e) {
        console.error("Feil ved henting av event:", e);
        setLoadError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [eventId]);

  // Nå gjør denne KUN logging – navigasjon håndteres i EventForm (goBackToCalendar)
  const handleUpdated = (updated) => {
    console.log("Event oppdatert:", updated);
  };

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto p-6">
        <p>Laster event…</p>
      </div>
    );
  }

  if (loadError || !eventData) {
    return (
      <div className="max-w-3xl mx-auto p-6">
        <p className="text-red-600">
          Klarte ikke å hente event: {loadError || "Ukjent feil"}
        </p>
      </div>
    );
  }

  return (
    <EventForm
      mode="edit"
      initialEvent={eventData}
      onUpdated={handleUpdated}
      defaultStoreScope={eventData.storeScope || "BOTH"}
    />
  );
}
